<template lang="pug">
  div
    sidebar
      transition-group.group-list(
        name="list-complete",
        mode="out-in",
        tag="ul")
        li.list-complete-item(key="profile")
          router-link.group-link(:to="{name: 'profile'}")
            //icon(name="address-card")
            span {{$t('profile')}}
        li.list-complete-item(v-if="AppState.perm.isAdmin && !AppState.isMobile", key="managers")
          router-link.group-link(:to="{name: 'managers'}")
            //icon(name="users-cog")
            //- span {{$t('user')}}{{$t('manage')}}
            span {{$t('users')}}
        li.list-complete-item(v-if="AppState.perm.isAdmin", key="groups")
          router-link.group-link(:to="{name: 'group-root'}")
            //icon(name="object-group")
            //- span {{$t('group')}}{{$t('manage')}}
            span {{$t('groups')}}
        template(v-if="!AppState.isStandalone")
          li.list-complete-item(v-if="AppState.perm.isAdmin && !AppState.isMobile", key="license")
            router-link.group-link(:to="{name: 'license'}")
              //icon(name="credit-card")
              span {{$t('subscription')}}
          li.list-complete-item(v-if="AppState.perm.isAdmin && !AppState.isMobile", key="payments")
            router-link.group-link(:to="{name: 'payments'}")
              //icon(name="money-check-alt")
              span {{$t('payment_history')}}
        template(v-if="AppState.perm.isApprover")
          li.list-complete-item(v-if="!AppState.perm.isAdmin && summary.use_approval", key="access-user")
            router-link.group-link(:to="{name: 'access-user'}")
              //icon(name="history")
              span {{$t('request-history')}}
          template(v-if="AppState.perm.isAdmin || AppState.perm.isSubManager")
            li.list-complete-item(key="access")
              router-link.group-link(:to="{name: 'access-registration'}")
                //icon(name="file-signature")
                span {{$t('approval-process')}}
            li.list-complete-item(key="access-history")
              router-link.group-link(:to="{name: 'access-registration-view'}")
                //icon(name="history")
                span {{$t('approval-process-history')}}
        template(v-if="AppState.perm.isAdmin")
          li.list-complete-item(v-if="summary.common_policy" key="function-settings")
            router-link.group-link(:to="{name: 'function-settings'}")
              //icon(name="wrench")
              span {{$t('function-settings')}}
          li.list-complete-item(v-if="summary.ip_policy" key="blocking-settings")
            router-link.group-link(:to="{name: 'blocking-settings'}")
              //icon(name="shield-alt")
              span {{$t('blocking-settings')}}
      template(v-if="licenseFlag")
        div.license-desc
          //span(v-html="$t('payment_account_info')")
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from '../mixins/sidebar'
import store from '@/api/store'

export default {
  name: 'manage-component',
  components: { 'sidebar': Sidebar },
  methods: {
    getUserData () {
      let stored = store.get('summary')
      this.summary = stored
    }
  },
  watch: {
    $route (to) {
      to.name === 'license' ? this.licenseFlag = true : this.licenseFlag = false
    }
  },
  created () {
    this.getUserData()
    this.licenseFlag = this.$route.name === 'license'
  },
  data () {
    return {
      summary: {},
      licenseFlag: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.group-list {
  padding: 0;
  margin: 15px 0 0 9px;
  list-style: none;
  font-size: 14px;
  
  li {
    height: 35px;
    line-height: 35px;

    .group-link {
      display: block;
      width: 100%;
      padding: 0 0 0 12px;
      text-align: left;
      font-weight: 400;
      color: #6F6F6F;

      &.router-link-exact-active,
      &.router-link-active {
        color: #EC7211;
        //background-color: #38d2b8;
        > span { font-weight: bolder; }
      }
      &:hover {
        // background-color: #16232d;
        color: #16191F;
      }
      > svg { vertical-align: middle; }
      > span {
        display: inline-block;
        padding: 1px 10px;
        vertical-align: top;
      }
    }

    &.active .group-link {
      background-color: #38d2b8;
      color: #fff;
    }
  }
}

.list-complete-item {
  transition: transform 500ms;
}
.list-complete-enter {
  transform: translateX(-220px);
}
.list-complete-leave-to {
  // transform: translateX(220px);
  display: none;
}
.list-complete-leave-active {
  // position: absolute;
}

.license-desc {
  margin-top: 5rem;
  padding: 10px;
  text-align: center;
  line-height: 1.5;
}
</style>
